import { createNode, PlainTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainTime } from '../../utils/temporal';

export const TimeNode = createNode({
    id: 'Time',
    name: 'Time',
    description: 'Creates a Time value from hour, minute, second, and millisecond components',
    aiDescription:
        'Takes number inputs on "Hour", "Minute", and optionally "Second" and "Millisecond" ports, and outputs a Time on the "Time" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Hour: { kind: 'number' },
        Minute: { kind: 'number' },
        Second: { kind: 'number' },
        Millisecond: { kind: 'number' },
    },
    optionalInPorts: ['Second', 'Millisecond'],
    outPorts: {
        Time: PlainTimeDataType,
    },
    execute: function (input) {
        const time = Temporal.PlainTime.from({
            hour: input.inPorts.Hour,
            minute: input.inPorts.Minute,
            second: input.inPorts.Second ?? 0,
            millisecond: input.inPorts.Millisecond ?? 0,
        });
        return { output: { Time: fromPlainTime(time) } };
    },
});
